module.exports = __webpack_public_path__ + "img/image2.64eb570.png";